<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
  @import url(https://cdn.datatables.net/1.10.21/css/jquery.dataTables.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.1.3/css/bootstrap.css);
	@import url(./assets/css/bootstrap.min.css);
	@import url(./assets/css/icons.css);
	@import url(./assets/css/metisMenu.min.css);
	@import url(./assets/css/style.css);
	@import url(./assets/custom-css/custom-css.css);
</style>

<script>

  import MainLayout from '@/views/main.vue'
  export default {
    components: {
      MainLayout
    },
    mounted () {
    }
  }
</script>

